import * as React from 'react';

const FacebookLoginIcon = (props) => (
    <svg width={33} height={32} fill="none" {...props}>
        <path
            fill="#3975EA"
            d="M13.833 31.822C6.278 30.49.5 23.912.5 16c0-8.8 7.2-16 16-16s16 7.2 16 16c0 7.911-5.778 14.489-13.333 15.822l-.89-.71h-3.555l-.889.71Z"
        />
        <path
            fill="#fff"
            d="M22.72 20.445 23.433 16h-4.267v-3.11c0-1.245.445-2.223 2.4-2.223h2.045V6.578c-1.156-.178-2.4-.355-3.556-.355-3.644 0-6.222 2.222-6.222 6.222V16h-4v4.445h4v11.289c.889.177 1.778.266 2.667.266.889 0 1.777-.088 2.666-.266v-11.29h3.556Z"
        />
    </svg>
);
export default FacebookLoginIcon;
